import { injectable } from 'inversify';
import Scene = Phaser.Scene;
import {ResourcePlace} from "@/store/place/types";
import PlaceStore from "@/store/place";
import TextUtils from "@/utils/text-utils";
import PlayerStore from "@/store/player";
import {InterfaceMode} from "@/store/player/types";

@injectable()
export class ResourceService {

    private scene: Scene | undefined;
    private quantityOfGatheredItemsInfoText!: Phaser.GameObjects.Text;

    public takeResource(scene: Scene, place: ResourcePlace, x: number, y: number): void {
        this.scene = scene;

        PlaceStore.takeResource(place.id);

        if(PlayerStore.getPlayer().interfaceMode === InterfaceMode.ORIGINAL) {
            this.showGatheringInfo(place, x, y);
            // this.showGatheringEffect(x, y);
        }
    }

    private showGatheringInfo(lootData: ResourcePlace, x: number, y: number): void {

        if (this.quantityOfGatheredItemsInfoText) {
            this.quantityOfGatheredItemsInfoText.destroy();
        }

        this.quantityOfGatheredItemsInfoText = this.scene!.add.text(x, y, TextUtils.formatMoney(lootData.count), {
            fontFamily: 'GothicDeutsch',
            fontSize: '20px',
            color: '#fcba03'});

        this.scene!.tweens.chain({
            targets: this.quantityOfGatheredItemsInfoText,
            tweens: [{
            },
                {
                    y: y - 25,
                    duration: 500,
                },
                {
                    x: x,
                    y: y - 75,
                    alpha: 0,
                    delay: 0,
                    duration: 1000
                }]
        })
    }
}
